
import { Vue, Component, Watch } from "vue-property-decorator";
import { getCaseList } from "@/apis/about";
import VideoPlay from "@/components/video-play-model.vue";
import PictureSlide from "./components/PictureSlide.vue";
import { formatUpyunUrl } from "@/utils";
import Business from "@/components/Business.vue";
import { generateMetaInfo } from "@/utils/seo";
@Component({
  components: { VideoPlay, PictureSlide, Business }
})
export default class Layout extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "关于光华 | 杭州光华赋能教育科技有限公司，始于2003年的企业培训咨询机构 - 光华赋能",
      description:
        "杭州光华赋能教育科技有限公司（原时代光华），始于2003年，专注企业科学经营培训与咨询陪跑20余年。提供BLM科学经营、实战EMBA、企业内训、管理微咨询、数字化绩效系统等服务，累计服务上万家企业。",
      keywords:
        "关于光华,光华赋能,杭州光华赋能,时代光华,企业培训公司,管理咨询机构,企业介绍,光华赋能官网",
      path: "/about",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "关于光华" }
      ]
    });
  }

  info: any = "暂无内容";
  formatUpyunUrl = formatUpyunUrl;

  medalArr: any = [
    {
      img: require("@/assets/medal/medal0.png"),
      alt: "二零一九年最佳学习型企业"
    },
    {
      img: require("@/assets/medal/medal1.png"),
      alt: "2015年度浙江省优秀管理咨询与培训企业"
    },
    {
      img: require("@/assets/medal/medal2.png"),
      alt: "浙江省电商培训10强"
    },
    {
      img: require("@/assets/medal/medal3.png"),
      alt: "2015优秀电子商务统计单位"
    },
    {
      img: require("@/assets/medal/medal4.png"),
      alt: "浙江省企业经营管理人才培训基地"
    },
    {
      img: require("@/assets/medal/medal5.png"),
      alt: "浙江省企业管理咨询培训行业示范机构"
    },
    {
      img: require("@/assets/medal/medal6.png"),
      alt: "浙江省电子商务促进会理事单位"
    },
    {
      img: require("@/assets/medal/medal7.png"),
      alt: "2014优秀电子商务统计单位"
    },
    {
      img: require("@/assets/medal/medal8.png"),
      alt: "浙江省优秀培训机构"
    },
    {
      img: require("@/assets/medal/medal9.png"),
      alt: "电子商务人才培训中心"
    },
    {
      img: require("@/assets/medal/medal10.png"),
      alt: "浙江省企业培训师联盟"
    },
    {
      img: require("@/assets/medal/medal11.png"),
      alt: "中国企业培训行业十年贡献奖"
    }
  ];
  medalStr = this.medalArr[0].alt;
  caseList: any = [];
  created() {
    this.init();
  }

  async init() {
    const data = await getCaseList({
      per_page: 8
    });

    this.caseList = data.data || [];
    this.caseList.map((item: any) => {
      item.thumb_url = item.thumb_url
        ? item.thumb_url
        : "/gh_website/img-default.png";
    });
  }
  clickCase(item: any) {
    this.$router.push(`/case-detail/${item.case_id}?page=1`);
  }

  bannerChange(index: any) {
    this.medalStr = this.medalArr[index].alt;
    console.log("bannerChange", index);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
